// extracted by mini-css-extract-plugin
module.exports = {"NewsForm":"NewsForm_NewsForm__bn1n3","Error":"NewsForm_Error__3FQrO"};